(function () {
  "use strict";

  /*
    SPARC STICKY PRODUCT HERO
    Internal revision: V5.2 — DRIVER + CLASSIC 3100 DYNAMIC STAGE SUPPORT

    Keep existing Shopify asset filenames:
      sparc-sticky-product-hero-v1.js
      sparc-sticky-product-hero-v1.css

    V5.2:
    - Retains the approved V4.8 sticky behavior and soft handoff.
    - Keeps the existing stable non-shrinking stage floor for Muscle and the
      other series that still use the original stage behavior.
    - Driver and Classic 3100 both own live product-stage heights that grow
      AND shrink with the active accordion.
    - The shared sticky release boundary now follows the CURRENT stage height
      for Driver and Classic 3100 instead of remembering the tallest tab.
    - Muscle behavior is unchanged.
    - Retains sticky-series-nav coordination and reload safety.
  */

  if (window.__SPARC_STICKY_PRODUCT_HERO_V5_2__) return;
  window.__SPARC_STICKY_PRODUCT_HERO_V5_2__ = true;

  var BREAKPOINT = 860;
  var TOP_GAP = 20;
  var BOTTOM_GAP = 20;

  /*
    Only the positioning-mode handoff is eased.
    The hero does NOT lag behind scroll while moving normally.
  */
  var HANDOFF_MS = 180;

  var PANEL_IDS = [
    "sparc-muscle-configurator",
    "sparc-muscle-round-configurator",
    "sparc-driver-configurator",
    "sparc-heritage-configurator",
    "sparc-classic-3100-configurator",
    "sparc-classic-squarebody-configurator",
    "sparc-garage-configurator"
  ];

  var state = null;
  var rafPending = false;
  var startupTimer = null;
  var resizeObserver = null;
  var resizeTimer = null;
  var startupSettled = false;

  function visible(node) {
    if (!node) return false;

    var rect = node.getBoundingClientRect();
    var style = window.getComputedStyle(node);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== "none" &&
      style.visibility !== "hidden"
    );
  }

  function activePanel() {
    for (var i = 0; i < PANEL_IDS.length; i++) {
      var panel = document.getElementById(PANEL_IDS[i]);

      if (panel && visible(panel)) {
        return panel;
      }
    }

    return null;
  }

  function containsGallery(node) {
    if (!node) return false;

    return !!node.querySelector(
      ".product-single__photos," +
      ".product-single__featured-image-wrapper," +
      ".product-single__photo," +
      ".product-single__featured-image," +
      "[data-product-single-thumbnail]"
    );
  }

  function findOptionsColumn(panel) {
    if (!panel) return null;

    var node = panel;

    while (node && node !== document.body) {
      if (
        node.classList &&
        node.classList.contains("grid__item")
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return panel.parentElement;
  }

  function findStage(optionsColumn) {
    if (!optionsColumn) return null;

    var node = optionsColumn.parentElement;

    while (node && node !== document.body) {
      var children = Array.prototype.slice.call(
        node.children || []
      );

      var hasGallerySibling = children.some(
        function (child) {
          return (
            child !== optionsColumn &&
            containsGallery(child)
          );
        }
      );

      if (hasGallerySibling) {
        return node;
      }

      if (
        node.classList &&
        (
          node.classList.contains("product-single") ||
          node.id === "ProductSection"
        )
      ) {
        if (containsGallery(node)) {
          return node;
        }
      }

      node = node.parentElement;
    }

    return null;
  }

  function findHeroColumn(stage, optionsColumn) {
    if (!stage) return null;

    var direct = Array.prototype.slice.call(
      stage.children || []
    );

    for (var i = 0; i < direct.length; i++) {
      var child = direct[i];

      if (
        child !== optionsColumn &&
        containsGallery(child)
      ) {
        return child;
      }
    }

    var galleryNode = stage.querySelector(
      ".product-single__photos," +
      ".product-single__featured-image-wrapper," +
      ".product-single__photo," +
      ".product-single__featured-image"
    );

    if (!galleryNode) return null;

    var node = galleryNode;

    while (
      node &&
      node.parentElement &&
      node.parentElement !== stage
    ) {
      if (
        node.classList &&
        node.classList.contains("grid__item")
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return node || null;
  }

  function normalizeWrapper(hero) {
    if (!hero) return null;

    var old =
      hero.querySelector(
        ":scope > .sparc-sticky-product-hero-v4__inner"
      ) ||
      hero.querySelector(
        ":scope > .sparc-sticky-product-hero__inner"
      ) ||
      hero.querySelector(
        ":scope > .sparc-fixed-hero-test"
      );

    if (old) {
      old.className =
        "sparc-sticky-product-hero-v4__inner";

      old.removeAttribute("style");

      return old;
    }

    var inner =
      document.createElement("div");

    inner.className =
      "sparc-sticky-product-hero-v4__inner";

    while (hero.firstChild) {
      inner.appendChild(
        hero.firstChild
      );
    }

    hero.appendChild(inner);

    return inner;
  }

  function fixedHeaderBottom() {
    var nodes =
      Array.prototype.slice.call(
        document.querySelectorAll(
          "header,.site-header,#SiteHeader,.header-wrapper,#sparc-steering-series-nav"
        )
      );

    var bottom = 0;

    nodes.forEach(
      function (node) {
        if (!visible(node)) return;

        var style =
          window.getComputedStyle(node);

        if (
          style.position !== "fixed" &&
          style.position !== "sticky"
        ) {
          return;
        }

        var rect =
          node.getBoundingClientRect();

        if (
          rect.top <= 3 &&
          rect.bottom > 0
        ) {
          bottom =
            Math.max(
              bottom,
              rect.bottom
            );
        }
      }
    );

    return bottom;
  }

  function topOffset() {
    return Math.round(
      Math.max(
        TOP_GAP,
        fixedHeaderBottom() + 14
      )
    );
  }

  function currentScrollThresholds() {
    if (!state) {
      return {
        start:
          0,

        release:
          0,

        offset:
          topOffset()
      };
    }

    var offset =
      topOffset();

    /*
      Unlike V4.2, these thresholds are intentionally dynamic.
      The series navigation starts in normal document flow and later becomes
      sticky. Its height should affect the hero only after it is actually
      pinned at the top of the viewport.
    */
    return {
      start:
        state.naturalTop -
        offset,

      release:
        state.stageDocBottom -
        BOTTOM_GAP -
        state.naturalHeight -
        offset,

      offset:
        offset
    };
  }

  function scrollX() {
    return (
      window.pageXOffset ||
      document.documentElement.scrollLeft ||
      0
    );
  }

  function scrollY() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0
    );
  }

  function clearPositionStyles(inner) {
    if (!inner) return;

    [
      "position",
      "top",
      "left",
      "width",
      "z-index",
      "margin",
      "transform",
      "transition"
    ].forEach(
      function (prop) {
        inner.style.removeProperty(
          prop
        );
      }
    );

    inner.classList.remove(
      "sparc-hero-soft-handoff"
    );
  }

  function finishHandoff(token) {
    if (
      !state ||
      token !==
        state.handoffToken
    ) {
      return;
    }

    window.clearTimeout(
      state.handoffTimer
    );

    state.handoffTimer =
      null;

    state.inner.classList.remove(
      "sparc-hero-soft-handoff"
    );

    state.inner.style.removeProperty(
      "transition"
    );

    state.inner.style.removeProperty(
      "transform"
    );
  }

  /*
    SOFT MODE HANDOFF
    -----------------
    Capture the hero's exact viewport position before changing CSS modes.
    Apply the new mode. Offset it back to that same visible position for one
    frame, then ease only that positional correction to zero.

    This creates softness only at the stop/start. The hero never follows
    the mouse wheel while scrolling normally or while sticky.
  */
  function softSwitch(
    nextMode,
    applyMode
  ) {
    if (!state) return;

    if (
      state.mode ===
      nextMode
    ) {
      applyMode(
        false
      );

      return;
    }

    var inner =
      state.inner;

    var before =
      inner.getBoundingClientRect();

    state.handoffToken += 1;

    var token =
      state.handoffToken;

    window.clearTimeout(
      state.handoffTimer
    );

    inner.classList.remove(
      "sparc-hero-soft-handoff"
    );

    inner.style.setProperty(
      "transition",
      "none",
      "important"
    );

    inner.style.setProperty(
      "transform",
      "none",
      "important"
    );

    /*
      Perform the positioning-mode switch instantly, while still hidden by
      the transform continuity calculation below.
    */
    applyMode(
      true
    );

    var after =
      inner.getBoundingClientRect();

    var deltaX =
      before.left -
      after.left;

    var deltaY =
      before.top -
      after.top;

    /*
      Put the hero back at the exact pre-switch screen position.
    */
    inner.style.setProperty(
      "transform",
      "translate3d(" +
        deltaX.toFixed(3) +
        "px," +
        deltaY.toFixed(3) +
        "px,0)",
      "important"
    );

    void inner.offsetWidth;

    inner.classList.add(
      "sparc-hero-soft-handoff"
    );

    inner.style.setProperty(
      "transition",
      "transform " +
        HANDOFF_MS +
        "ms cubic-bezier(.18,.82,.24,1)",
      "important"
    );

    window.requestAnimationFrame(
      function () {
        if (
          !state ||
          token !==
            state.handoffToken
        ) {
          return;
        }

        inner.style.setProperty(
          "transform",
          "translate3d(0,0,0)",
          "important"
        );
      }
    );

    state.handoffTimer =
      window.setTimeout(
        function () {
          finishHandoff(
            token
          );
        },
        HANDOFF_MS + 40
      );
  }

  function applyNormal(
    fromSwitch
  ) {
    if (!state) return;

    function apply() {
      state.inner.style.setProperty(
        "position",
        "relative",
        "important"
      );

      state.inner.style.removeProperty(
        "top"
      );

      state.inner.style.removeProperty(
        "left"
      );

      state.inner.style.setProperty(
        "width",
        "100%",
        "important"
      );

      state.inner.style.removeProperty(
        "z-index"
      );

      state.inner.style.removeProperty(
        "margin"
      );

      state.mode =
        "before";
    }

    if (fromSwitch) {
      apply();
      return;
    }

    if (
      state.mode ===
      "before"
    ) {
      apply();
      return;
    }

    softSwitch(
      "before",
      function () {
        apply();
      }
    );
  }

  function discover() {
    var panel =
      activePanel();

    if (!panel) {
      return null;
    }

    var options =
      findOptionsColumn(panel);

    var stage =
      findStage(options);

    var hero =
      findHeroColumn(
        stage,
        options
      );

    if (
      !options ||
      !stage ||
      !hero
    ) {
      console.warn(
        "[SPARC STICKY PRODUCT HERO V5.1] Layout discovery waiting.",
        {
          panel: panel,
          options: options,
          stage: stage,
          hero: hero
        }
      );

      return null;
    }

    var inner =
      normalizeWrapper(hero);

    if (!inner) {
      return null;
    }

    hero.style.setProperty(
      "position",
      "relative",
      "important"
    );

    hero.style.setProperty(
      "overflow",
      "visible",
      "important"
    );

    stage.style.setProperty(
      "overflow",
      "visible",
      "important"
    );

    clearPositionStyles(inner);

    return {
      panel: panel,
      options: options,
      stage: stage,
      hero: hero,
      inner: inner,

      naturalTop: 0,
      naturalLeft: 0,
      naturalWidth: 0,
      naturalHeight: 0,

      heroDocTop: 0,
      heroDocLeft: 0,
      stageDocBottom: 0,

      startScroll: 0,
      releaseScroll: 0,
      releasedTop: 0,
      releasedLeft: 0,

      mode: "before",
      handoffTimer: null,
      handoffToken: 0,

      stageDocTop: 0,
      stageFloorHeight: 0,
      stagePriorMinHeight:
        stage.style.getPropertyValue(
          "min-height"
        ),
      stagePriorMinHeightPriority:
        stage.style.getPropertyPriority(
          "min-height"
        )
    };
  }

  function panelOwnsDynamicStageHeight() {
    if (
      !state ||
      !state.panel
    ) {
      return false;
    }

    return (
      state.panel.id ===
        "sparc-driver-configurator" ||
      state.panel.id ===
        "sparc-classic-3100-configurator"
    );
  }

  function restoreOriginalStageMinHeight() {
    if (!state || !state.stage) return;

    /*
      Driver and Classic 3100 have their own live product-stage height controllers.
      Do not overwrite or restore that min-height from the shared sticky
      controller. Muscle and the other series keep the original behavior.
    */
    if (panelOwnsDynamicStageHeight()) {
      return;
    }

    if (
      state.stagePriorMinHeight
    ) {
      state.stage.style.setProperty(
        "min-height",
        state.stagePriorMinHeight,
        state.stagePriorMinHeightPriority || ""
      );
    } else {
      state.stage.style.removeProperty(
        "min-height"
      );
    }
  }

  function applyStageFloor() {
    if (
      !state ||
      !state.stage ||
      state.stageFloorHeight <= 0
    ) {
      return;
    }

    /*
      Driver / Classic 3100 configurator JS controls the stage min-height dynamically.
      The shared sticky controller must only READ that height, never freeze it.
    */
    if (panelOwnsDynamicStageHeight()) {
      return;
    }

    state.stage.style.setProperty(
      "min-height",
      Math.ceil(
        state.stageFloorHeight
      ) + "px",
      "important"
    );
  }

  function establishStageFloor(
    stageRect,
    pageY
  ) {
    if (
      !state ||
      !stageRect
    ) {
      return;
    }

    state.stageDocTop =
      stageRect.top +
      pageY;

    state.stageFloorHeight =
      Math.max(
        0,
        stageRect.height
      );

    applyStageFloor();

    state.stageDocBottom =
      state.stageDocTop +
      state.stageFloorHeight;
  }

  function growStageFloorFromCurrentLayout() {
    if (!state) return;

    var y =
      scrollY();

    var stageRect =
      state.stage.getBoundingClientRect();

    var innerRect =
      state.inner.getBoundingClientRect();

    state.stageDocTop =
      stageRect.top +
      y;

    /*
      Driver and Classic 3100 are intentionally different from the other series:
      its configurator owns a live stage height that grows AND shrinks with
      the active accordion. The sticky release boundary must follow that
      current height exactly.

      Every other series keeps the approved V5.0 non-shrinking floor.
    */
    if (panelOwnsDynamicStageHeight()) {
      state.stageFloorHeight =
        Math.max(
          0,
          stageRect.height
        );
    } else if (
      stageRect.height >
      state.stageFloorHeight
    ) {
      state.stageFloorHeight =
        stageRect.height;
    }

    applyStageFloor();

    state.stageDocBottom =
      state.stageDocTop +
      state.stageFloorHeight;

    if (
      innerRect.height > 0
    ) {
      state.naturalHeight =
        innerRect.height;
    }

    state.releasedTop =
      Math.max(
        0,
        state.stageDocBottom -
        state.heroDocTop -
        state.naturalHeight -
        BOTTOM_GAP
      );

    state.releaseScroll =
      state.stageDocBottom -
      BOTTOM_GAP -
      state.naturalHeight -
      topOffset();
  }

  function measureNatural() {
    if (!state) return;

    /*
      Force normal flow before measuring. This is critical after browser
      scroll restoration and after any previous sticky/released state.
    */
    clearPositionStyles(
      state.inner
    );

    state.inner.style.setProperty(
      "position",
      "relative",
      "important"
    );

    state.inner.style.setProperty(
      "width",
      "100%",
      "important"
    );

    var y = scrollY();
    var x = scrollX();

    var innerRect =
      state.inner.getBoundingClientRect();

    var heroRect =
      state.hero.getBoundingClientRect();

    var stageRect =
      state.stage.getBoundingClientRect();

    state.naturalTop =
      innerRect.top + y;

    state.naturalLeft =
      innerRect.left + x;

    state.naturalWidth =
      innerRect.width;

    state.naturalHeight =
      innerRect.height;

    state.heroDocTop =
      heroRect.top + y;

    state.heroDocLeft =
      heroRect.left + x;

    establishStageFloor(
      stageRect,
      y
    );

    var offset =
      topOffset();

    /*
      Sticky begins when the natural hero reaches the viewport offset.
    */
    state.startScroll =
      state.naturalTop -
      offset;

    /*
      Sticky ends when the bottom of the fixed hero would touch the bottom
      containment boundary of the product/configurator stage.
    */
    state.releaseScroll =
      state.stageDocBottom -
      BOTTOM_GAP -
      state.naturalHeight -
      offset;

    /*
      Released state is absolutely anchored inside the hero column at the
      stage's bottom boundary. This is what prevents a reload below the
      configurator from forcing the hero back into viewport-fixed mode.
    */
    state.releasedTop =
      Math.max(
        0,
        state.stageDocBottom -
        state.heroDocTop -
        state.naturalHeight -
        BOTTOM_GAP
      );

    state.releasedLeft =
      state.naturalLeft -
      state.heroDocLeft;

    if (
      state.naturalHeight > 0
    ) {
      state.hero.style.setProperty(
        "min-height",
        state.naturalHeight + "px",
        "important"
      );
    }

    state.mode = "measured";
  }

  function applySticky(
    offset,
    fromSwitch
  ) {
    if (!state) return;

    var x =
      scrollX();

    var liveOffset =
      typeof offset === "number"
        ? offset
        : topOffset();

    function apply() {
      state.inner.style.setProperty(
        "position",
        "fixed",
        "important"
      );

      state.inner.style.setProperty(
        "top",
        liveOffset + "px",
        "important"
      );

      state.inner.style.setProperty(
        "left",
        (
          state.naturalLeft -
          x
        ) + "px",
        "important"
      );

      state.inner.style.setProperty(
        "width",
        state.naturalWidth + "px",
        "important"
      );

      state.inner.style.setProperty(
        "z-index",
        "20",
        "important"
      );

      state.inner.style.setProperty(
        "margin",
        "0",
        "important"
      );

      state.mode =
        "sticky";
    }

    if (fromSwitch) {
      apply();
      return;
    }

    if (
      state.mode ===
      "sticky"
    ) {
      /*
        Through the sticky region, update geometry immediately.
        No lag or easing while the hero is supposed to be stationary.
      */
      apply();
      return;
    }

    softSwitch(
      "sticky",
      function () {
        apply();
      }
    );
  }

  function applyReleased(
    fromSwitch
  ) {
    if (!state) return;

    function apply() {
      state.inner.style.setProperty(
        "position",
        "absolute",
        "important"
      );

      state.inner.style.setProperty(
        "top",
        state.releasedTop + "px",
        "important"
      );

      state.inner.style.setProperty(
        "left",
        state.releasedLeft + "px",
        "important"
      );

      state.inner.style.setProperty(
        "width",
        state.naturalWidth + "px",
        "important"
      );

      state.inner.style.setProperty(
        "z-index",
        "4",
        "important"
      );

      state.inner.style.setProperty(
        "margin",
        "0",
        "important"
      );

      state.mode =
        "released";
    }

    if (fromSwitch) {
      apply();
      return;
    }

    if (
      state.mode ===
      "released"
    ) {
      apply();
      return;
    }

    softSwitch(
      "released",
      function () {
        apply();
      }
    );
  }

  function attach() {
    var found =
      discover();

    if (!found) {
      return false;
    }

    state = found;

    measureNatural();

    installResizeObserver();

    console.info(
      "[SPARC STICKY PRODUCT HERO V5.1] Active.",
      {
        panel: state.panel,
        stage: state.stage,
        hero: state.hero,
        startScroll:
          Math.round(
            state.startScroll
          ),
        releaseScroll:
          Math.round(
            state.releaseScroll
          ),
        restoredScroll:
          Math.round(
            scrollY()
          ),

        liveTopOffset:
          topOffset()
      }
    );

    queueUpdate();

    return true;
  }

  function ensureState() {
    if (
      state &&
      document.body.contains(
        state.panel
      ) &&
      document.body.contains(
        state.stage
      ) &&
      document.body.contains(
        state.hero
      ) &&
      document.body.contains(
        state.inner
      )
    ) {
      return true;
    }

    return attach();
  }

  function update() {
    rafPending = false;

    if (!startupSettled) {
      return;
    }

    if (
      !ensureState()
    ) {
      return;
    }

    if (
      window.innerWidth <=
      BREAKPOINT
    ) {
      applyNormal(
        false
      );

      state.hero.style.removeProperty(
        "min-height"
      );

      restoreOriginalStageMinHeight();

      return;
    }

    var y =
      scrollY();

    var thresholds =
      currentScrollThresholds();

    /*
      Three explicit states using the LIVE sticky-navigation offset.
    */
    if (
      y <
      thresholds.start
    ) {
      applyNormal(
        false
      );
      return;
    }

    if (
      y <=
      thresholds.release
    ) {
      applySticky(
        thresholds.offset,
        false
      );
      return;
    }

    applyReleased(
      false
    );
  }

  function queueUpdate() {
    if (rafPending) return;

    rafPending = true;

    window.requestAnimationFrame(
      update
    );
  }

  function remeasureAfterLayoutChange() {
    window.clearTimeout(
      resizeTimer
    );

    resizeTimer =
      window.setTimeout(
        function () {
          if (!state) return;

          growStageFloorFromCurrentLayout();
          queueUpdate();
        },
        35
      );
  }

  function installResizeObserver() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }

    if (
      typeof ResizeObserver ===
      "undefined" ||
      !state
    ) {
      return;
    }

    resizeObserver =
      new ResizeObserver(
        function () {
          /*
            Driver follows the live stage height in both directions.
            All other series retain the approved grow-only stage floor.
          */
          remeasureAfterLayoutChange();
        }
      );

    resizeObserver.observe(
      state.stage
    );

    resizeObserver.observe(
      state.inner
    );

    /*
      Driver / Classic 3100 panel is the source of the dynamic stage-height changes.
      Observing it directly guarantees a boundary refresh after a tab closes
      to a shorter height as well as after a taller tab opens.
    */
    if (panelOwnsDynamicStageHeight()) {
      resizeObserver.observe(
        state.panel
      );
    }
  }

  function settleScrollRestorationAndStart() {
    /*
      Browsers can restore the previous scroll position after DOMContentLoaded
      and even after initial deferred scripts have started.

      Wait until window load, then two animation frames plus a short settle
      delay before establishing natural geometry.
    */
    window.requestAnimationFrame(
      function () {
        window.requestAnimationFrame(
          function () {
            window.setTimeout(
              function () {
                startupSettled = true;

                if (!state) {
                  attach();
                } else {
                  measureNatural();
                  queueUpdate();
                }
              },
              90
            );
          }
        );
      }
    );
  }

  function start() {
    var attempts = 0;

    startupTimer =
      window.setInterval(
        function () {
          attempts += 1;

          if (
            activePanel() ||
            attempts >= 80
          ) {
            window.clearInterval(
              startupTimer
            );

            startupTimer = null;

            if (
              document.readyState ===
              "complete"
            ) {
              settleScrollRestorationAndStart();
            } else {
              window.addEventListener(
                "load",
                settleScrollRestorationAndStart,
                {
                  once: true
                }
              );
            }
          }
        },
        250
      );

    window.addEventListener(
      "scroll",
      queueUpdate,
      {
        passive: true
      }
    );

    window.addEventListener(
      "resize",
      function () {
        if (!state) {
          queueUpdate();
          return;
        }

        applyNormal(
          false
        );

        /*
          A true viewport resize is allowed to establish a new floor because
          the responsive layout itself has changed.
        */
        restoreOriginalStageMinHeight();

        state.stageFloorHeight =
          0;

        if (
          window.innerWidth <=
          BREAKPOINT
        ) {
          state.hero.style.removeProperty(
            "min-height"
          );

          queueUpdate();
          return;
        }

        window.setTimeout(
          function () {
            measureNatural();
            queueUpdate();
          },
          80
        );
      }
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
